var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-banner"},[_c('div',[_c('img',{attrs:{"src":require("../../assets/mobile/icon/5.png"),"alt":""}}),_c('a',{attrs:{"href":"tel:021-62680166"}},[_vm._v(_vm._s(_vm.lang === 'zh' ? '电话' : 'Tel')+"：021-62680166")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }